import externalScriptService from './services/externalScript.service';

const coreModule = angular.module('journey-ui.shared.core', [])
  .factory('externalScriptService', externalScriptService);

export default coreModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/core/index.js